import React, { FC, lazy, Suspense } from 'react';
import { useParams } from 'react-router-dom';

import AppLayout from '../../components/app-layout/index';
import Loader from '../../components/loader/index';
import { AuthGuard } from '../../guards/index';
import { SubscriptionOffer } from '../subscription-offer/index';

const Billing = lazy(() => import('./index'));

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// /billing/:id serves two audiences: the authenticated company checkout (:id is a company UUID)
// and the public subscription-offer activation link (/billing/{slug}). Offer slugs are base64url
// and never UUID-shaped, so the param shape picks the branch — the offer landing must stay
// public or the guard would bounce a guest to /login before the offer is stored.
export const BillingEntry: FC = () => {
  const { id } = useParams<{ id: string }>();

  if (id && !UUID_PATTERN.test(id)) return <SubscriptionOffer />;

  return (
    <AuthGuard>
      <AppLayout>
        <Suspense fallback={<Loader />}>
          <Billing />
        </Suspense>
      </AppLayout>
    </AuthGuard>
  );
};
